"use client";
import { ModalType } from "@/modules/Insta/Modal/Modal";
import { useRouter } from "next/compat/router";
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

export interface IContextType {
  openMenu: boolean;
  setOpenMenu: Dispatch<SetStateAction<boolean>>;
  openPopup: boolean;
  setopenPopup: Dispatch<SetStateAction<boolean>>;
  instagramModal: ModalType | null;
  setInstagramModal: Dispatch<SetStateAction<ModalType | null>>;
  navbarSize: { width: number; height: number };
  setNavbarSize: Dispatch<SetStateAction<{ width: number; height: number }>>;
  isHomeIntroComplete: boolean;
  setIsHomeIntroComplete: Dispatch<SetStateAction<boolean>>;
  isNobleElements: boolean;
}

const AppContext = createContext<IContextType | null>(null);

export const AppProvider = ({
  children,
  isNobleElements,
}: {
  children: React.ReactNode;
  isNobleElements: boolean;
}) => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openPopup, setopenPopup] = useState<boolean>(false);
  const [instagramModal, setInstagramModal] = useState<ModalType | null>(null);
  const [navbarSize, setNavbarSize] = useState<{
    width: number;
    height: number;
  }>({ width: 0, height: 0 });
  const [isHomeIntroComplete, setIsHomeIntroComplete] =
    useState<boolean>(false);
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setOpenMenu(false);
    };
    // Subscribe to the route change event
    router?.events.on("routeChangeStart", handleRouteChange);

    // Cleanup the event listener when the component is unmounted
    return () => {
      router?.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router?.events]);

  return (
    <AppContext.Provider
      value={{
        openMenu,
        setOpenMenu,
        openPopup,
        setopenPopup,
        instagramModal,
        setInstagramModal,
        navbarSize,
        setNavbarSize,
        isHomeIntroComplete,
        setIsHomeIntroComplete,
        isNobleElements,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): IContextType => {
  const context = useContext<IContextType | null>(AppContext);

  if (context === undefined || context === null) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
};
